import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _0e433b93 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _23099730 = () => interopDefault(import('../pages/complains.vue' /* webpackChunkName: "pages/complains" */))
const _e64111b4 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _4c92363e = () => interopDefault(import('../pages/documents.vue' /* webpackChunkName: "pages/documents" */))
const _ca324bc8 = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _6a067571 = () => interopDefault(import('../pages/finance-report.vue' /* webpackChunkName: "pages/finance-report" */))
const _1b7098e3 = () => interopDefault(import('../pages/how-to-apply.vue' /* webpackChunkName: "pages/how-to-apply" */))
const _6a89bb8a = () => interopDefault(import('../pages/how-to-repay.vue' /* webpackChunkName: "pages/how-to-repay" */))
const _6804a7e3 = () => interopDefault(import('../pages/insurance/index.vue' /* webpackChunkName: "pages/insurance/index" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _455a88bd = () => interopDefault(import('../pages/offices.vue' /* webpackChunkName: "pages/offices" */))
const _4bb7511c = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _a17d832c = () => interopDefault(import('../pages/recover.vue' /* webpackChunkName: "pages/recover" */))
const _41d65b66 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _74dc1cce = () => interopDefault(import('../pages/rollover-otp.vue' /* webpackChunkName: "pages/rollover-otp" */))
const _64c96752 = () => interopDefault(import('../pages/select-verification.vue' /* webpackChunkName: "pages/select-verification" */))
const _f21c7624 = () => interopDefault(import('../pages/social-fund/index.vue' /* webpackChunkName: "pages/social-fund/index" */))
const _662fd27a = () => interopDefault(import('../pages/video-capture.vue' /* webpackChunkName: "pages/video-capture" */))
const _bafb3120 = () => interopDefault(import('../pages/application/accepted.vue' /* webpackChunkName: "pages/application/accepted" */))
const _48149816 = () => interopDefault(import('../pages/application/apply.vue' /* webpackChunkName: "pages/application/apply" */))
const _55b5fb03 = () => interopDefault(import('../pages/application/loading.vue' /* webpackChunkName: "pages/application/loading" */))
const _6ad45c67 = () => interopDefault(import('../pages/application/loading-video-verification.vue' /* webpackChunkName: "pages/application/loading-video-verification" */))
const _4766fd09 = () => interopDefault(import('../pages/application/manual-verification.vue' /* webpackChunkName: "pages/application/manual-verification" */))
const _3b32b3f8 = () => interopDefault(import('../pages/application/offer-decrease.vue' /* webpackChunkName: "pages/application/offer-decrease" */))
const _c49590c8 = () => interopDefault(import('../pages/application/offer-increase.vue' /* webpackChunkName: "pages/application/offer-increase" */))
const _92aace72 = () => interopDefault(import('../pages/application/rejected.vue' /* webpackChunkName: "pages/application/rejected" */))
const _062b41b6 = () => interopDefault(import('../pages/insurance/delay-decision.vue' /* webpackChunkName: "pages/insurance/delay-decision" */))
const _ea66eb24 = () => interopDefault(import('../pages/profile/biometry/index.vue' /* webpackChunkName: "pages/profile/biometry/index" */))
const _7d7cc1b8 = () => interopDefault(import('../pages/profile/change-password.vue' /* webpackChunkName: "pages/profile/change-password" */))
const _9b53d4cc = () => interopDefault(import('../pages/profile/edit.vue' /* webpackChunkName: "pages/profile/edit" */))
const _2bf9a991 = () => interopDefault(import('../pages/profile/my-loan.vue' /* webpackChunkName: "pages/profile/my-loan" */))
const _35fff11c = () => interopDefault(import('../pages/profile/no-loan.vue' /* webpackChunkName: "pages/profile/no-loan" */))
const _5cd712d6 = () => interopDefault(import('../pages/profile/repayment/index.vue' /* webpackChunkName: "pages/profile/repayment/index" */))
const _80ca490c = () => interopDefault(import('../pages/registration/step2.vue' /* webpackChunkName: "pages/registration/step2" */))
const _80ae1a0a = () => interopDefault(import('../pages/registration/step3.vue' /* webpackChunkName: "pages/registration/step3" */))
const _8091eb08 = () => interopDefault(import('../pages/registration/step4.vue' /* webpackChunkName: "pages/registration/step4" */))
const _8075bc06 = () => interopDefault(import('../pages/registration/step5.vue' /* webpackChunkName: "pages/registration/step5" */))
const _72a2a758 = () => interopDefault(import('../pages/social-fund/loading.vue' /* webpackChunkName: "pages/social-fund/loading" */))
const _2a3be650 = () => interopDefault(import('../pages/profile/biometry/loading.vue' /* webpackChunkName: "pages/profile/biometry/loading" */))
const _71fe7cdc = () => interopDefault(import('../pages/profile/biometry/rejected.vue' /* webpackChunkName: "pages/profile/biometry/rejected" */))
const _19193d40 = () => interopDefault(import('../pages/profile/repayment/bank-transfer.vue' /* webpackChunkName: "pages/profile/repayment/bank-transfer" */))
const _1f0747e8 = () => interopDefault(import('../pages/profile/rollover/_id.vue' /* webpackChunkName: "pages/profile/rollover/_id" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _59ba53f2 = () => interopDefault(import('../node_modules/@sf/core/pages/flow.vue' /* webpackChunkName: "" */))
const _943633aa = () => interopDefault(import('../node_modules/@sf/core/admin/login.vue' /* webpackChunkName: "" */))
const _ae311c12 = () => interopDefault(import('../node_modules/@sf/core/admin/router.vue' /* webpackChunkName: "" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'active-url',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/o-kompanii",
      component: _0e433b93,
      name: "about___ru"
    }, {
      path: "/kg/kompaniya-jonundo",
      component: _0e433b93,
      name: "about___kg"
    }, {
      path: "/complains",
      component: _23099730,
      name: "complains___ru"
    }, {
      path: "/kg/complains",
      component: _23099730,
      name: "complains___kg"
    }, {
      path: "/contacty",
      component: _e64111b4,
      name: "contact___ru"
    }, {
      path: "/kg/bailanysh-maalymat",
      component: _e64111b4,
      name: "contact___kg"
    }, {
      path: "/documenty",
      component: _4c92363e,
      name: "documents___ru"
    }, {
      path: "/kg/documentter",
      component: _4c92363e,
      name: "documents___kg"
    }, {
      path: "/voprosy-otvety",
      component: _ca324bc8,
      name: "faq___ru"
    }, {
      path: "/kg/suroo-joop",
      component: _ca324bc8,
      name: "faq___kg"
    }, {
      path: "/finance-report",
      component: _6a067571,
      name: "finance-report___ru"
    }, {
      path: "/kg/finance-report",
      component: _6a067571,
      name: "finance-report___kg"
    }, {
      path: "/kak-podat-zayavku",
      component: _1b7098e3,
      name: "how-to-apply___ru"
    }, {
      path: "/kg/zayavkany-beruu",
      component: _1b7098e3,
      name: "how-to-apply___kg"
    }, {
      path: "/kak-pogasit-zaym",
      component: _6a89bb8a,
      name: "how-to-repay___ru"
    }, {
      path: "/kg/zaymdy-toloo-joldoru",
      component: _6a89bb8a,
      name: "how-to-repay___kg"
    }, {
      path: "/insurance",
      component: _6804a7e3,
      name: "insurance___ru"
    }, {
      path: "/kg/insurance",
      component: _6804a7e3,
      name: "insurance___kg"
    }, {
      path: "/login",
      component: _10ba8d22,
      name: "login___ru"
    }, {
      path: "/kg/login",
      component: _10ba8d22,
      name: "login___kg"
    }, {
      path: "/offices",
      component: _455a88bd,
      name: "offices___ru"
    }, {
      path: "/kg/offices",
      component: _455a88bd,
      name: "offices___kg"
    }, {
      path: "/profile",
      component: _4bb7511c,
      name: "profile___ru"
    }, {
      path: "/kg/profile",
      component: _4bb7511c,
      name: "profile___kg"
    }, {
      path: "/vosstanovit-parol",
      component: _a17d832c,
      name: "recover___ru"
    }, {
      path: "/kg/syr-sozdu-estoo",
      component: _a17d832c,
      name: "recover___kg"
    }, {
      path: "/registraciya",
      component: _41d65b66,
      name: "registration___ru"
    }, {
      path: "/kg/kattoo",
      component: _41d65b66,
      name: "registration___kg"
    }, {
      path: "/rollover-otp",
      component: _74dc1cce,
      name: "rollover-otp___ru"
    }, {
      path: "/kg/rollover-otp",
      component: _74dc1cce,
      name: "rollover-otp___kg"
    }, {
      path: "/select-verification",
      component: _64c96752,
      name: "select-verification___ru"
    }, {
      path: "/kg/select-verification",
      component: _64c96752,
      name: "select-verification___kg"
    }, {
      path: "/social-fund",
      component: _f21c7624,
      name: "social-fund___ru"
    }, {
      path: "/kg/social-fund",
      component: _f21c7624,
      name: "social-fund___kg"
    }, {
      path: "/video-capture",
      component: _662fd27a,
      name: "video-capture___ru"
    }, {
      path: "/kg/video-capture",
      component: _662fd27a,
      name: "video-capture___kg"
    }, {
      path: "/application/accepted",
      component: _bafb3120,
      name: "application-accepted___ru"
    }, {
      path: "/kg/application/accepted",
      component: _bafb3120,
      name: "application-accepted___kg"
    }, {
      path: "/application/apply",
      component: _48149816,
      name: "application-apply___ru"
    }, {
      path: "/kg/application/apply",
      component: _48149816,
      name: "application-apply___kg"
    }, {
      path: "/application/loading",
      component: _55b5fb03,
      name: "application-loading___ru"
    }, {
      path: "/kg/application/loading",
      component: _55b5fb03,
      name: "application-loading___kg"
    }, {
      path: "/application/loading-video-verification",
      component: _6ad45c67,
      name: "application-loading-video-verification___ru"
    }, {
      path: "/kg/application/loading-video-verification",
      component: _6ad45c67,
      name: "application-loading-video-verification___kg"
    }, {
      path: "/application/manual-verification",
      component: _4766fd09,
      name: "application-manual-verification___ru"
    }, {
      path: "/kg/application/manual-verification",
      component: _4766fd09,
      name: "application-manual-verification___kg"
    }, {
      path: "/application/offer-decrease",
      component: _3b32b3f8,
      name: "application-offer-decrease___ru"
    }, {
      path: "/kg/application/offer-decrease",
      component: _3b32b3f8,
      name: "application-offer-decrease___kg"
    }, {
      path: "/application/offer-increase",
      component: _c49590c8,
      name: "application-offer-increase___ru"
    }, {
      path: "/kg/application/offer-increase",
      component: _c49590c8,
      name: "application-offer-increase___kg"
    }, {
      path: "/application/rejected",
      component: _92aace72,
      name: "application-rejected___ru"
    }, {
      path: "/kg/application/rejected",
      component: _92aace72,
      name: "application-rejected___kg"
    }, {
      path: "/insurance/delay-decision",
      component: _062b41b6,
      name: "insurance-delay-decision___ru"
    }, {
      path: "/kg/insurance/delay-decision",
      component: _062b41b6,
      name: "insurance-delay-decision___kg"
    }, {
      path: "/profile/biometry",
      component: _ea66eb24,
      name: "profile-biometry___ru"
    }, {
      path: "/kg/profile/biometry",
      component: _ea66eb24,
      name: "profile-biometry___kg"
    }, {
      path: "/profile/change-password",
      component: _7d7cc1b8,
      name: "profile-change-password___ru"
    }, {
      path: "/kg/profile/change-password",
      component: _7d7cc1b8,
      name: "profile-change-password___kg"
    }, {
      path: "/profile/edit",
      component: _9b53d4cc,
      name: "profile-edit___ru"
    }, {
      path: "/kg/profile/edit",
      component: _9b53d4cc,
      name: "profile-edit___kg"
    }, {
      path: "/profile/my-loan",
      component: _2bf9a991,
      name: "profile-my-loan___ru"
    }, {
      path: "/kg/profile/my-loan",
      component: _2bf9a991,
      name: "profile-my-loan___kg"
    }, {
      path: "/profile/no-loan",
      component: _35fff11c,
      name: "profile-no-loan___ru"
    }, {
      path: "/kg/profile/no-loan",
      component: _35fff11c,
      name: "profile-no-loan___kg"
    }, {
      path: "/profile/repayment",
      component: _5cd712d6,
      name: "profile-repayment___ru"
    }, {
      path: "/kg/profile/repayment",
      component: _5cd712d6,
      name: "profile-repayment___kg"
    }, {
      path: "/registration/step2",
      component: _80ca490c,
      name: "registration-step2___ru"
    }, {
      path: "/kg/registration/step2",
      component: _80ca490c,
      name: "registration-step2___kg"
    }, {
      path: "/registration/step3",
      component: _80ae1a0a,
      name: "registration-step3___ru"
    }, {
      path: "/kg/registration/step3",
      component: _80ae1a0a,
      name: "registration-step3___kg"
    }, {
      path: "/registration/step4",
      component: _8091eb08,
      name: "registration-step4___ru"
    }, {
      path: "/kg/registration/step4",
      component: _8091eb08,
      name: "registration-step4___kg"
    }, {
      path: "/registration/step5",
      component: _8075bc06,
      name: "registration-step5___ru"
    }, {
      path: "/kg/registration/step5",
      component: _8075bc06,
      name: "registration-step5___kg"
    }, {
      path: "/social-fund/loading",
      component: _72a2a758,
      name: "social-fund-loading___ru"
    }, {
      path: "/kg/social-fund/loading",
      component: _72a2a758,
      name: "social-fund-loading___kg"
    }, {
      path: "/profile/biometry/loading",
      component: _2a3be650,
      name: "profile-biometry-loading___ru"
    }, {
      path: "/kg/profile/biometry/loading",
      component: _2a3be650,
      name: "profile-biometry-loading___kg"
    }, {
      path: "/profile/biometry/rejected",
      component: _71fe7cdc,
      name: "profile-biometry-rejected___ru"
    }, {
      path: "/kg/profile/biometry/rejected",
      component: _71fe7cdc,
      name: "profile-biometry-rejected___kg"
    }, {
      path: "/profile/repayment/bank-transfer",
      component: _19193d40,
      name: "profile-repayment-bank-transfer___ru"
    }, {
      path: "/kg/profile/repayment/bank-transfer",
      component: _19193d40,
      name: "profile-repayment-bank-transfer___kg"
    }, {
      path: "/profile/rollover/:id?",
      component: _1f0747e8,
      name: "profile-rollover-id___ru"
    }, {
      path: "/kg/profile/rollover/:id?",
      component: _1f0747e8,
      name: "profile-rollover-id___kg"
    }, {
      path: "/",
      component: _2dfb1658,
      name: "index___ru"
    }, {
      path: "/kg/",
      component: _2dfb1658,
      name: "index___kg"
    }, {
      path: "/flow",
      component: _59ba53f2,
      name: "flow___ru"
    }, {
      path: "/kg/flow",
      component: _59ba53f2,
      name: "flow___kg"
    }, {
      path: "/admin",
      component: _943633aa,
      name: "admin___ru"
    }, {
      path: "/kg/admin",
      component: _943633aa,
      name: "admin___kg"
    }, {
      path: "/admin/router",
      component: _ae311c12,
      name: "admin-router___ru"
    }, {
      path: "/kg/admin/router",
      component: _ae311c12,
      name: "admin-router___kg"
    }],

    fallback: false
  })
}
